import { ComponentType, Suspense, useEffect } from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import toastr from 'toastr';
import Authorization from '../../Helpers/Authorization';
import Footer from '../Common/Footer';
import Header from '../Common/Header';
import SideBar from '../Common/SideBar';
import NotAuthroized from '../NotFound/NotAuthorized';
import Loader from '../Common/loader';
import type { LegacyRouteProps } from '../../routes';

interface ProtectedRouteContentProps {
  component: ComponentType<LegacyRouteProps>;
}

export function ProtectedRouteContent({
  component: Component,
}: ProtectedRouteContentProps) {
  const location = useLocation();
  const params = useParams();
  const role = Authorization.getAuthUserRole();

  return (
    <Component
      path={role === 'CSSUPPORT' ? '/cssupport' : '/track-trace'}
      location={location}
      match={{ params }}
    />
  );
}

function ProtectedLayout() {
  const location = useLocation();
  const isLoggedIn = Authorization.isLoggedIn();
  const role = Authorization.getAuthUserRole();
  const isUnauthorizedRoute =
    role === 'CUSTOMERADMIN' &&
    ['/profiles/dealer', '/profiles/customer-admin'].includes(
      location.pathname
    );

  useEffect(() => {
    if (isLoggedIn) {
      return;
    }

    sessionStorage.setItem(
      'proute',
      JSON.stringify({
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
      })
    );
    toastr.error('Please login to continue.');
  }, [isLoggedIn]);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (isUnauthorizedRoute) {
    return (
      <div>
        <NotAuthroized />
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Header />
      {location.pathname !== '/cssupport' && <SideBar />}
      <main>
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}

export default ProtectedLayout;
